<!-- Este es el layout de la parte pública. Las rutas que usan este layout no requieren que el usuario esté autenticado -->
<template>
 
  <slot></slot>
</template>

<script setup lang="ts"></script>

<style scoped lang="scss">
#logo-header {
  height: 4rem;
}
</style>
